import {
  Grid,
  Typography,
  Slider,
  Button,
  Checkbox,
  CircularProgress,
  Tooltip,
  TextField,
} from "@material-ui/core";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  KeyboardArrowDown,
  KeyboardArrowRight,
} from "@material-ui/icons";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import React, { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { globalStyles } from "../../assets/globalStyles";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { useStyles } from "./filterStyles";
import {
  selectSliderTemp,
  setSliderTemp,
  selectMesswertLoading,
  selectMessstellen,
  selectFilteredMessstellenOfGroup,
  selectMessstelleWertTemp,
  setMessstelleWertTemp,
  setIsChangedMessstelle,
  setSelectedGroups,
  setOpenGroups,
  setMessstelleSelectInputValue,
  selectopenGroups,
  selectSelectedGroups,
  selectMessstelleSelectInputValue,
} from "./messstellenFilterSlice";


export default function MessstellenFilter(props: {
  name: string;
}): ReactElement {
  const dispatch = useAppDispatch();
  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const name = props.name;

  const slider = useAppSelector(selectSliderTemp);

  const messwertLoading = useAppSelector(selectMesswertLoading);
  const messstellen = useAppSelector(selectMessstellen);
  const aktuellerWertTemp = useAppSelector(selectMessstelleWertTemp);
  const messstellenwertSelectInputValue = useAppSelector(selectMessstelleSelectInputValue);
  const openGroups = useAppSelector(selectopenGroups);
  const selectedGroups = useAppSelector(selectSelectedGroups);

  const marks = [
    {
      value: -0.1,
      label: "- ∞",
    },
    {
      value: 0.0,
      label: "0",
    },
    {
      value: 0.1,
      label: "0.1",
    },
    {
      value: 0.2,
      label: "0.2",
    },
    {
      value: 0.3,
      label: "0.3",
    },
    {
      value: 0.4,
      label: "0.4",
    },
    {
      value: 0.5,
      label: "0.5",
    },
    {
      value: 0.6,
      label: "0.6",
    },
    {
      value: 0.7,
      label: "0.7",
    },
    {
      value: 0.8,
      label: "0.8",
    },
    {
      value: 0.9,
      label: "0.9",
    },

    {
      value: 1.0,
      label: "1",
    },
  ];

  return (
    <div>
      <Grid item md={12} style={{ marginBottom: "20px" }} />
      <Grid item md={12} style={{ textAlign: "left" }}>
        <Typography color="primary">Messstellenauswahl</Typography>
        <Autocomplete
          id="select-messwert"
          limitTags={1}
          multiple
          filterOptions={
            createFilterOptions({
              stringify: option => option.umspannwerk + option.name + option.schaltfeld
            })
          }
          disableCloseOnSelect
          noOptionsText={
            <React.Fragment>
              {messwertLoading ? (
                <CircularProgress style={{ padding: "5px" }} />
              ) : (
                "Keine Messwerte"
              )}
            </React.Fragment>
          }
          value={aktuellerWertTemp}
          onChange={(_, newValue) => {
            dispatch(setMessstelleWertTemp(newValue));
            dispatch(setIsChangedMessstelle(true));
            dispatch(
              setSelectedGroups(
                newValue
                  .filter((x) => {
                    const allMessstellenForThisUW = messstellen.filter(
                      (mv) =>
                        mv.umspannwerk == x.umspannwerk
                    ).length;
                    const selectedMessstellenForThisUW = newValue.filter(
                      (mv) =>
                       mv.umspannwerk == x.umspannwerk 
                    ).length;
                    return (
                      allMessstellenForThisUW == selectedMessstellenForThisUW
                    );
                  })
                  .map(
                    (x) =>  x.umspannwerk
                  )
              )
            );
          }}
          onClose={() => {
            dispatch(setMessstelleSelectInputValue(""));
          }}
          inputValue={messstellenwertSelectInputValue}
          onInputChange={(_, newInputValue, reason) => {
            if (reason == "reset") return;
            dispatch(setMessstelleSelectInputValue(newInputValue));
          }}
          options={messstellen}
          getOptionLabel={(option) => {
            const optionName =
                option.schaltfeld +
                " (" +
                option.name +
                ")"
              
            return optionName;
          }}
          groupBy={(option) => {
            const groupingName = option.umspannwerk;
            return groupingName;
          }}
          renderGroup={(params) => {
            return messstellen.every((x) => x.umspannwerk != null) ? (
              <React.Fragment>
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="small" />}
                  checkedIcon={<CheckBox fontSize="small" />}
                  style={{ marginRight: -10 }}
                  indeterminate={
                    !selectedGroups.includes(params.group) &&
                    aktuellerWertTemp.some((k) => k.umspannwerk == params.group)
                  }
                  checked={selectedGroups.includes(params.group)}
                  onChange={() => {
                    if (selectedGroups.includes(params.group)) {
                      dispatch(
                        setSelectedGroups(
                          selectedGroups.filter((x) => x != params.group)
                        )
                      );
                      dispatch(
                        selectFilteredMessstellenOfGroup({
                          groups: selectedGroups.filter(
                            (x) => x != params.group
                          ),
                          filter: messstellenwertSelectInputValue,
                        })
                      );
                      dispatch(setIsChangedMessstelle(true));
                    } else {
                      dispatch(
                        setSelectedGroups(selectedGroups.concat([params.group]))
                      );
                      dispatch(
                        selectFilteredMessstellenOfGroup({
                          groups: selectedGroups.concat([params.group]),
                          filter: messstellenwertSelectInputValue,
                        })
                      );
                      dispatch(setIsChangedMessstelle(true));
                    }
                  }}
                />
                <Button
                  style={{
                    fontWeight: "bold",
                    textTransform: "none",
                    fontSize: "medium",
                  }}
                  onClick={() =>
                    openGroups.includes(params.group)
                      ? dispatch(
                          setOpenGroups(
                            openGroups.filter((x) => x != params.group)
                          )
                        )
                      : dispatch(
                          setOpenGroups(openGroups.concat([params.group]))
                        )
                  }
                >
                  {openGroups.includes(params.group) ? (
                    <KeyboardArrowDown style={{ marginRight: 10 }} />
                  ) : (
                    <KeyboardArrowRight style={{ marginRight: 10 }} />
                  )}
                  {params.group}
                </Button>
                {openGroups.includes(params.group) ? params.children : ""}
                <br />
              </React.Fragment>
            ) : (
              params.children
            );
          }}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={<CheckBoxOutlineBlank fontSize="small" />}
                checkedIcon={<CheckBox fontSize="small" />}
                style={{
                  marginLeft: 12,
                  marginRight: 12,
                  paddingTop: 1,
                  paddingBottom: 1,
                }}
                checked={selected}
              />
              {option.schaltfeld +
                " (" +
                option.name +
                ")"}
            </React.Fragment>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Messstelle"
              variant="outlined"
              classes={{ root: classes.textFieldRoot }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    <div>
                      <Tooltip title="Alle Messstellenwerte selektieren">
                        <Button
                          size="small"
                          variant="contained"
                          color="secondary"
                          disabled={messwertLoading}
                          onClick={() => {
                            dispatch(
                              setSelectedGroups(
                                messstellen.map((x) => x.umspannwerk)
                              )
                            );
                            dispatch(
                              selectFilteredMessstellenOfGroup({
                                groups: null,
                                filter: messstellenwertSelectInputValue,
                              })
                            );
                            dispatch(setIsChangedMessstelle(true));
                          }}
                        >
                          <DoneAllIcon />
                          Alle
                        </Button>
                      </Tooltip>
                      {params.InputProps.endAdornment}
                    </div>
                  </React.Fragment>
                ),
              }}
            />
          )}
          className={classes.selectEmpty}
        />
      </Grid>
      <Grid item md={12} style={{ marginBottom: "30px" }} />
      {name == "pqIndex" ? (
        <Grid item md={12} style={{ textAlign: "left", marginRight: "35px" }}>
          <Typography color="primary">PQ Index der Messstellen</Typography>
          <Slider
            value={[...slider]}
            step={0.1}
            marks={marks}
            min={-0.1}
            max={1.0}
            valueLabelDisplay="auto"
            aria-labelledby="range-slider"
            onChange={(_, nV) => {
              dispatch(setSliderTemp(nV as number[]));
            }}
            onChangeCommitted={(_, nV) => {
              dispatch(setSliderTemp(nV as number[]));
              dispatch(setIsChangedMessstelle(true));
            }}
            className={classes.marks}
            style={{ marginTop: "10px", marginLeft: "15px" }}
          />
        </Grid>
      ) : (
        ""
      )}
    </div>
  );
}
